import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, timeout } from 'rxjs';
import { IAuthUser } from '../interfaces/auth-user.interface';

@Injectable({ providedIn: 'root' })
export class AuthApiService {
  private readonly http = inject(HttpClient);
  getCurrentUserInfo(): Observable<IAuthUser> {
    return this.http
      .get<IAuthUser>(`${environment.API_URL}/user/profile`)
      .pipe(timeout(30_000));
  }
}
